import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { Heading } from '@/common/components/heading';
import { EmptyState, EmptyStateImage, EmptyStateMessage } from '@/shared/components/empty-states';

export const Route = createFileRoute(
  '/wizard/memberships/$member-number/automatic-payments/'
)({
  component: AutomaticPaymentsPage
});

function AutomaticPaymentsPage() {
  const { membership } = Route.useRouteContext();

  return (
    <>
      <Heading>Automatic Payments</Heading>
      <EmptyState>
        <EmptyStateImage src="/img/wizard_automatic_payments.svg" alt="An illustration of a laptop with three green leaves on the screen."/>
        <EmptyStateMessage>
          Would you like to set up automatic payments?
        </EmptyStateMessage>
        <ButtonGroup vertical className="min-w-52">
          <Button
            to="/wizard/memberships/$member-number/automatic-payments/setup"
            params={{ 'member-number': membership.member_number.toString() }}
          >
            Set Up Automatic Payments
          </Button>
          <Button
            to="/wizard/memberships/$member-number/complete"
            params={{ 'member-number': membership.member_number.toString() }}
            outline
          >
            No Thanks
          </Button>
        </ButtonGroup>
      </EmptyState>
    </>
  );
}
